import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolSettingsService } from "../..";

@Component({
	selector: "app-schoolemaildomain",
	templateUrl: "./schoolemaildomain.component.html",
	styleUrls: ["./schoolemaildomain.component.css"],
})
export class SchoolemaildomainComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private schoolSettingsService: SchoolSettingsService,
		private confirmationService: ConfirmationService
	) {}

	schoolEmailData = {
		DomainName: "",
		MakeDefault: false,
		DefinedBy: 0,
	};

	SchoolID: any;
	user: any;

	ngOnInit(): void {
		this.user = this.dialogConfig.data.User;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.schoolEmailData = this.dialogConfig.data.EmailData;
	}

	///////////////////////////
	// Buttons
	//////////////////////////

	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}

	onAddAndKeep() {
		//Call SP to Update Email
		this.UpdateEmail(0);

		this.onClose();
	}

	onAddAndDelete() {
		//Call SP to update and delete
		this.UpdateEmail(1);

		this.onClose();
	}

	UpdateEmail(KeepOrDelete) {
		var ProviderName = this.getProviderName(this.schoolEmailData.DomainName);
		var ProviderInfo = this.getProviderInfo(this.schoolEmailData.DomainName);

		if (!this.schoolEmailData.DefinedBy) {
			this.schoolEmailData.DefinedBy = 3;
		}

		var result = this.schoolSettingsService.UpdateSchoolEmail(
			"",
			this.SchoolID,
			ProviderName,
			ProviderInfo,
			this.BoolToInt(this.schoolEmailData.MakeDefault),
			this.schoolEmailData.DefinedBy,
			KeepOrDelete
		);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Email Settings were Successfully Updated",
						header: "School Email Settings",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update School Email Settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	///////////////////////////

	///////////////////////////
	// Helpers
	//////////////////////////

	BoolToInt(val) {
		return val ? 1 : 0;
	}

	getProviderName(val) {
		var ans = val;

		var stop = ans.indexOf(".");

		if (stop >= 0) {
			ans = ans.substring(0, stop);
		}

		return ans;
	}

	getProviderInfo(val) {
		return val;
	}
	//////////////////////////
}
